module.exports = __webpack_public_path__ + "img/defaultLogo.43dc483a.png";